import { Button } from "@mui/material";
import { QUERY_KEYS } from "constant/react_query";
import { useUnitScanUpdate } from "hooks/citajteo/dl_unit/useUnitScanUpdate";
import toast from "react-hot-toast";
import styled from "styled-components";

type UnitScanFileNamesProps = {
  unitId: string;
  fileNames: string[];
  setFileNames: React.Dispatch<React.SetStateAction<string[]>>;
  resetFileNames: () => void;
};

const UnitScanFileNames = ({
  unitId,
  fileNames,
  setFileNames,
  resetFileNames,
}: UnitScanFileNamesProps) => {
  const { unitScanUpdateMutate } = useUnitScanUpdate({
    invalidateKeys: [
      QUERY_KEYS.CITAJTEO_DL_UNIT_SEARCH,
      QUERY_KEYS.CITAJTEO_DL_UNIT_GET,
    ],
  });

  if (!unitId) {
    return null;
  }

  const scanFileNamesUpdate = () => {
    unitScanUpdateMutate(
      { unitId, fileNames },
      {
        onSuccess: (data: any) => {
          console.log(data.msg);
          toast.success("Uspešno ažuriranje skenova jedinice.");
        },
        onError: (error) => {
          console.error("Error adding units:", error);
          toast.error("Greška pri unosu skenova jedinice.");
        },
      },
    );
  };

  return (
    <DivNav>
      <Button type="button" onClick={scanFileNamesUpdate}>
        OK
      </Button>
      <Button onClick={resetFileNames} type="button">
        Cancel
      </Button>
    </DivNav>
  );
};

const DivNav = styled.div`
  margin-top: 2rem;
  display: flex;
  gap: 0.75rem;
`;

export default UnitScanFileNames;
